import React, { useContext } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Breadcrumb, Button, Spin } from "antd";
import style from "./index.module.scss";
import useRequest from "utils/useRequest";
import { viewPaper, viewPaperListItem } from "service/question";
import _ from "underscore";
import { useAtomValue } from "jotai";
import {
    currentStudentAtom,
    questionnaireIdAtom,
    joinedStudentsAtom,
    useUpdateMarkList
} from "service/stores/Question/Students";
import { useUnmount } from "react-use";
import { CourseContext } from "pages/CourseDetail/Store";
import DetailLayout from "../../components/DetailLayout";
import CourseHeader from "../../components/CourseHeader";
import TopicReview from "./components/TopicReview";

export default function Review() {
    const history = useHistory();
    const { basename } = useContext(CourseContext);
    const { studentNo } = useParams<{
        questionnaireId: string;
        studentNo: string;
    }>();

    const questionnaireId = useAtomValue(questionnaireIdAtom);

    const [data, { loading }, refreshData] = useRequest(
        () => viewPaper(questionnaireId, studentNo),
        {},
        [questionnaireId, studentNo]
    );
    const students = useAtomValue(joinedStudentsAtom);

    const currentStu = useAtomValue(currentStudentAtom(studentNo));
    const currentIndex = students?.findIndex(
        (item: { studentNo: string; studentName: string }) =>
            item.studentNo === studentNo
    );

    const updateMarkList = useUpdateMarkList();

    // 注意, 不能随着批阅状态更新, 否则会造成列表不准的问题
    useUnmount(updateMarkList);

    function renderBreadcrumb() {
        return (
            <>
                <Breadcrumb.Item>
                    <Link
                        to={`${basename}/question/students/${questionnaireId}`}>
                        问卷详情
                    </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>查看提交</Breadcrumb.Item>
            </>
        );
    }

    function goPrev() {
        const next = students[currentIndex - 1];
        if (!next) return;
        history.replace(next.studentNo);
    }

    function goNext() {
        const next = students[currentIndex + 1];
        if (!next) return;
        history.replace(next.studentNo);
    }

    function renderButtons() {
        return (
            <div>
                {currentIndex === 0 && students && students.length !== 1 && (
                    <span className={style.firstStu}>当前是第一位学生</span>
                )}
                {!_.isNull(students) &&
                    !_.isUndefined(currentIndex) &&
                    currentIndex !== 0 && (
                        <Button className={style.btnPrev} onClick={goPrev}>
                            上一份
                        </Button>
                    )}
                {!_.isNull(students) &&
                    !_.isUndefined(currentIndex) &&
                    currentIndex !== students?.length - 1 && (
                        <Button className={style.btnNext} onClick={goNext}>
                            下一份
                        </Button>
                    )}
                {students &&
                    currentIndex === students?.length - 1 &&
                    students.length !== 1 && (
                        <span className={style.lastStu}>
                            当前是最后一位学生
                        </span>
                    )}
            </div>
        );
    }

    return (
        <DetailLayout breadcrumb={renderBreadcrumb()}>
            {currentStu && (
                <CourseHeader
                    title={`${currentStu.name} ${currentStu.studentNo}`}
                    info={`提交时间 ${data?.stuSubmitTime}`}
                    extra={renderButtons()}
                />
            )}
            <Spin spinning={loading}>
                <div className={style.root}>
                    <div className={style.topics}>
                        {data?.topics?.map(
                            (item: viewPaperListItem, index: number) => (
                                <TopicReview
                                    data={item}
                                    key={item.key}
                                    index={index}
                                />
                            )
                        )}
                    </div>
                </div>
            </Spin>
        </DetailLayout>
    );
}
